import TenantDTO from 'dto/tenants/tenantDTO';
import { IdentityProviderType } from 'models/identity/identityProvider';
import Tenant from 'models/tenants/tenant';
import { fromApiDateTimeOptional } from 'utils/datetime';
import { SubscriptionTypes } from 'utils/subscription';

export function mapFromTenant(tenantDTO: TenantDTO): Tenant {
  const tenant = new Tenant(tenantDTO.id, tenantDTO.name);
  tenant.parentId = tenantDTO.parentId;
  tenant.topLevelParentTenantId = tenantDTO.topLevelParentTenantId ?? tenantDTO.id;
  tenant.identityProviderType = tenantDTO.identityProviderType ?? IdentityProviderType.Entra;
  tenant.providerTenantId = tenantDTO.providerTenantId;
  tenant.created = fromApiDateTimeOptional(tenantDTO.created);
  tenant.subscriptionType = tenantDTO.subscriptionType ?? SubscriptionTypes.Trial;
  tenant.subscriptionEnd = fromApiDateTimeOptional(tenantDTO.subscriptionEnd);
  tenant.timeZoneCode = tenantDTO.timeZoneCode;
  tenant.color = tenantDTO.color;
  tenant.currentUserLicensed = tenantDTO.currentUserLicensed;

  return tenant;
}

export function mapFromTenants(tenantDTOs: TenantDTO[] | undefined): Tenant[] {
  return (tenantDTOs ?? []).map((tenantDTO) => mapFromTenant(tenantDTO));
}
